<template>
	<div class="apply_page">
		<div class="apply_form_pc" v-if="!isPhone">
			<div class="form_wrap">
				<p class="fm_tit1">剑南春专卖店特许加盟申请表</p>
				<p class="fm_tit2">填表时间：{{ nowdate }}</p>
				<div class="container_info">
					<div class="bgdiv">
						<p class="divtit">加盟城市基本情况</p>
						<div class="form_border">
							<el-form :model="formInfo" :rules="rules" ref="formInfo" label-width="100px" class="top_form"
								label-position="left">
								<div class="zdy_item">
									<p class="zdy_p"><label>*</label>拟开设城市:</p>
									<el-cascader size="large" :options="options" v-model="selectedOptions" @change="handleChange">
									</el-cascader>
								</div>
								<div class="zdy_item">
									<p class="zdy_p">行政级别:</p>
									<el-radio-group v-model="formInfo.xzlevel">
										<el-radio label="1">直辖市</el-radio>
										<el-radio label="2">省会城市</el-radio>
										<el-radio label="3">地级市</el-radio>
										<el-radio label="4">县</el-radio>
									</el-radio-group>
								</div>
								<div class="zdy_item">
									<p class="zdy_p">
										<label>*</label>基本经济指标:
									</p>
									<div class="economy_div">
										<el-form-item label="地区人口" prop="regionalPopulation">
											<el-input placeholder="请输入" v-model="
                                                formInfo.regionalPopulation
                                            ">
												<template slot="append">人</template>
											</el-input>
										</el-form-item>
										<el-form-item label="城市人口" prop="cityPopulation">
											<el-input placeholder="请输入" v-model="formInfo.cityPopulation">
												<template slot="append">人</template>
											</el-input>
										</el-form-item>
										<el-form-item label="区域财政收入" prop="revenue">
											<el-input placeholder="请输入" v-model="formInfo.revenue">
												<template slot="append">万元</template>
											</el-input>
										</el-form-item>
										<el-form-item label="人均GDP" prop="gdp">
											<el-input placeholder="请输入" v-model="formInfo.gdp">
												<template slot="append">万元</template>
											</el-input>
										</el-form-item>
									</div>
								</div>
								<div class="zdy_item">
									<p class="zdy_p">
										<label>*</label>经济特点及支柱产业介绍:
									</p>
									<el-input type="textarea" :rows="4" placeholder="请输入" v-model="formInfo.prodesc"
										resize="none"></el-input>
								</div>
							</el-form>
						</div>
					</div>
					<div class="bgdiv">
						<p class="divtit">加盟方基本情况</p>
						<div class="form_border" style="border-bottom: none;">
							<el-form :model="formInfo2" :rules="rules2" ref="formInfo2" label-width="110px" class="top_form bot_form"
								label-position="left">
								<div class="zdy_item">
									<p class="zdy_p"><label>*</label>公司名称:</p>
									<el-input placeholder="请输入" v-model="formInfo2.company"></el-input>
								</div>
								<div class="zdy_item">
									<div class="economy_div company_div">
										<el-form-item label="法人代表:" prop="legalPerson">
											<el-input placeholder="请输入" v-model="formInfo2.legalPerson"></el-input>
										</el-form-item>
										<el-form-item label="联系电话:" prop="legalPhone">
											<el-input placeholder="请输入" v-model="formInfo2.legalPhone"></el-input>
										</el-form-item>
										<el-form-item label="负责人姓名:" prop="fzrName">
											<el-input placeholder="请输入" v-model="formInfo2.fzrName"></el-input>
										</el-form-item>
										<el-form-item label="联系电话:" prop="fzrPhone">
											<el-input placeholder="请输入" v-model="formInfo2.fzrPhone"></el-input>
										</el-form-item>
									</div>
								</div>
								<div class="zdy_item">
									<p class="zdy_p"><label>*</label>加盟方预算:</p>
									<div class="economy_div">
										<el-form-item label="资金" prop="fund">
											<el-input placeholder="请输入" v-model="formInfo2.fund">
												<template slot="append">元</template>
											</el-input>
										</el-form-item>
										<el-form-item label="人员" prop="staff">
											<el-input placeholder="请输入" v-model="formInfo2.staff">
												<template slot="append">人</template>
											</el-input>
										</el-form-item>
										<el-form-item label="车辆" prop="carprice">
											<el-input placeholder="请输入" v-model="formInfo2.carprice">
												<template slot="append">元</template>
											</el-input>
										</el-form-item>
									</div>
								</div>
								<div class="zdy_item">
									<div class="economy_div company_div bank_div">
										<el-form-item label="开户行:" prop="bank">
											<el-input placeholder="请输入" v-model="formInfo2.bank"></el-input>
										</el-form-item>
										<el-form-item label="税号:" prop="bankNumber">
											<el-input placeholder="请输入" v-model="formInfo2.bankNumber"></el-input>
										</el-form-item>
										<el-form-item label="账户:" prop="account">
											<el-input placeholder="请输入" v-model="formInfo2.account"></el-input>
										</el-form-item>
										<el-form-item label="账号:" prop="accountNumber">
											<el-input placeholder="请输入" v-model="formInfo2.accountNumber"></el-input>
										</el-form-item>
										<el-form-item label="收货人:" prop="receiver">
											<el-input placeholder="请输入" v-model="formInfo2.receiver"></el-input>
										</el-form-item>
									</div>
								</div>
								<div class="zdy_item zdy_item2">
									<div class="economy_div company_div address_div">
										<el-form-item label="收货地址:" prop="address">
											<el-cascader size="large" :options="options" v-model="selectedOptions2" @change="handleChange2">
											</el-cascader>
										</el-form-item>
										<el-form-item label="详细地址:" prop="detailaddress">
											<el-input placeholder="请输入" v-model="formInfo2.detailaddress"></el-input>
										</el-form-item>
									</div>
								</div>
								<div class="zdy_item zdy_cont">
									<div class="zdy_txt">
										<div class="zdy_list">
											<p class="zdy_p">经营行业(非酒类):</p>
											<div class="add" @click="addItem">
												<i class="el-icon-plus"></i>添加
											</div>
										</div>
										<div class="zdy_list">
											<p class="zdy_p">年销售额:</p>
										</div>
									</div>
									<div class="zdy_input">
										<div class="input_box" v-for="(item, index) in operateItem" :key="index">
											<div class="input_div">
												<el-input v-model="item.industry" placeholder="请输入">
												</el-input>
												<el-input v-model="item.sales" placeholder="请输入">
													<template slot="append">万元</template>
												</el-input>
											</div>
											<div class="delinput">
												<span class="el-icon-remove" v-if="index !== 0" @click="deleteItem(item, index)"></span>
											</div>
										</div>
									</div>
								</div>
								<div class="zdy_item zdy_cont">
									<div class="zdy_txt">
										<div class="zdy_list">
											<p class="zdy_p">经营酒类品牌:</p>
											<div class="add" @click="addItem2">
												<i class="el-icon-plus"></i>添加
											</div>
										</div>
										<div class="zdy_list">
											<p class="zdy_p">年销售额:</p>
										</div>
									</div>
									<div class="zdy_input">
										<div class="input_box" v-for="(item, index) in operateItem2" :key="index">
											<div class="input_div">
												<el-input v-model="item.brand" placeholder="请输入"></el-input>
												<el-input v-model="item.sales" placeholder="请输入">
													<template slot="append">万元</template></el-input>
											</div>
											<div class="delinput">
												<span class="el-icon-remove" v-if="index !== 0" @click="
                                                    deleteItem2(item, index)
                                                "></span>
											</div>
										</div>
									</div>
								</div>
								<div class="zdy_item zdy_cont">
									<div class="zdy_txt">
										<div class="zdy_list">
											<p class="zdy_p">经营酒类专卖店:</p>
											<div class="add" @click="addItem3">
												<i class="el-icon-plus"></i>添加
											</div>
										</div>
										<div class="zdy_list">
											<p class="zdy_p">地址:</p>
										</div>
									</div>
									<div class="zdy_input">
										<div class="input_box" v-for="(item, index) in operateItem3" :key="index">
											<div class="input_div">
												<el-input v-model="item.shop" placeholder="请输入"></el-input>
												<el-input v-model="item.address" placeholder="请输入"></el-input>
											</div>
											<div class="delinput">
												<span class="el-icon-remove" v-if="index !== 0" @click="
                                                    deleteItem3(item, index)
                                                "></span>
											</div>
										</div>
									</div>
								</div>
								<div class="zdy_item">
									<p class="zdy_p">
										<label>*</label>主要团购网络及社会关系:
									</p>
									<el-input type="textarea" :rows="4" placeholder="请输入" v-model="formInfo2.other"
										resize="none"></el-input>
								</div>
							</el-form>
							<div class="notice">
								<i class="el-icon-warning-outline"></i>请认真核对以上信息准确无误，没有遗漏
							</div>
							<div class="btn_div">
								<div class="btn_divl" @click="save">提交</div>
								<div class="btn_divr" @click="reset">重置</div>
							</div>
						</div>
					</div>
				</div>
				<div class="rd_box">
					<record></record>
				</div>
			</div>
			<el-dialog :visible.sync="yzshow" :show-close="false" width="400px" top="20vh" center>
				<div class="yz_box">
					<p class="dj_ps">
						<span class="dj_ps_s1">请依次点击：</span>
						<span class="dj_ps_s2">{{yztext}}</span>
					</p>
					<div class="yzimg_con" @click="yanZheng">
						<img v-if="yzimg" class="yz_img" :src="yzimg" ref="imageRef1" />
						<div class="yz_cir" v-for="(item, index) in zbarr" :key="index"
							:style="{ left: (item.zbx-10) + 'px', top: (item.zby-10) + 'px' }">{{index+1 }}</div>
					</div>

					<div class="qr_btn2_box">
						<span @click="hqcaptcha">刷新</span>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="apply_form_phone" v-if="isPhone">
			<Header2 pageTitle="加盟申请"></Header2>
			<div class="form_wrap">
				<p class="fm_tit1">剑南春专卖店特许加盟申请表</p>
				<p class="fm_tit2">填表时间：{{ nowdate }}</p>
				<div class="container_info">
					<div class="bgdiv">
						<p class="divtit">加盟城市基本情况</p>
						<div class="form_border">
							<el-form :model="formInfo" :rules="rules" ref="formInfo" label-width="100px" class="top_form"
								label-position="left">
								<div class="zdy_item">
									<p class="zdy_p"><label>*</label>拟开设城市:</p>
									<el-cascader size="large" :options="options" v-model="selectedOptions" @change="handleChange">
									</el-cascader>
								</div>
								<div class="zdy_item xingzheng">
									<p class="zdy_p">行政级别:</p>
									<el-radio-group v-model="formInfo.xzlevel">
										<el-radio label="1">直辖市</el-radio>
										<el-radio label="2">省会城市</el-radio>
										<el-radio label="3">地级市</el-radio>
										<el-radio label="4">县</el-radio>
									</el-radio-group>
								</div>
								<div class="zdy_item">
									<p class="zdy_p">
										<label>*</label>基本经济指标:
									</p>
									<div class="economy_div">
										<el-form-item label="地区人口" prop="regionalPopulation">
											<el-input placeholder="请输入" v-model="
                                                formInfo.regionalPopulation
                                            ">
												<template slot="append">人</template>
											</el-input>
										</el-form-item>
										<el-form-item label="城市人口" prop="cityPopulation">
											<el-input placeholder="请输入" v-model="formInfo.cityPopulation">
												<template slot="append">人</template>
											</el-input>
										</el-form-item>
										<el-form-item label="区域财政收入" prop="revenue">
											<el-input placeholder="请输入" v-model="formInfo.revenue">
												<template slot="append">万元</template>
											</el-input>
										</el-form-item>
										<el-form-item label="人均GDP" prop="gdp">
											<el-input placeholder="请输入" v-model="formInfo.gdp">
												<template slot="append">万元</template>
											</el-input>
										</el-form-item>
									</div>
								</div>
								<div class="zdy_item">
									<p class="zdy_p">
										<label>*</label>经济特点及支柱产业介绍:
									</p>
									<el-input type="textarea" :rows="4" placeholder="请输入" v-model="formInfo.prodesc"
										resize="none"></el-input>
								</div>
							</el-form>
						</div>
					</div>
					<div class="bgdiv">
						<p class="divtit">加盟方基本情况</p>
						<div class="form_border" style="border-bottom: none;">
							<el-form :model="formInfo2" :rules="rules2" ref="formInfo2" label-width="110px" class="top_form bot_form"
								label-position="left">
								<div class="zdy_item">
									<p class="zdy_p"><label>*</label>公司名称:</p>
									<el-input placeholder="请输入" v-model="formInfo2.company"></el-input>
								</div>
								<div class="zdy_item">
									<div class="economy_div company_div">
										<el-form-item label="法人代表:" prop="legalPerson">
											<el-input placeholder="请输入" v-model="formInfo2.legalPerson"></el-input>
										</el-form-item>
										<el-form-item label="联系电话:" prop="legalPhone">
											<el-input placeholder="请输入" v-model="formInfo2.legalPhone"></el-input>
										</el-form-item>
										<el-form-item label="负责人姓名:" prop="fzrName">
											<el-input placeholder="请输入" v-model="formInfo2.fzrName"></el-input>
										</el-form-item>
										<el-form-item label="联系电话:" prop="fzrPhone">
											<el-input placeholder="请输入" v-model="formInfo2.fzrPhone"></el-input>
										</el-form-item>
									</div>
								</div>
								<div class="zdy_item">
									<p class="zdy_p"><label>*</label>加盟方预算:</p>
									<div class="economy_div">
										<el-form-item label="资金" prop="fund">
											<el-input placeholder="请输入" v-model="formInfo2.fund">
												<template slot="append">元</template>
											</el-input>
										</el-form-item>
										<el-form-item label="人员" prop="staff">
											<el-input placeholder="请输入" v-model="formInfo2.staff">
												<template slot="append">人</template>
											</el-input>
										</el-form-item>
										<el-form-item label="车辆" prop="carprice">
											<el-input placeholder="请输入" v-model="formInfo2.carprice">
												<template slot="append">元</template>
											</el-input>
										</el-form-item>
									</div>
								</div>
								<div class="zdy_item">
									<div class="economy_div company_div bank_div">
										<el-form-item label="开户行:" prop="bank">
											<el-input placeholder="请输入" v-model="formInfo2.bank"></el-input>
										</el-form-item>
										<el-form-item label="税号:" prop="bankNumber">
											<el-input placeholder="请输入" v-model="formInfo2.bankNumber"></el-input>
										</el-form-item>
										<el-form-item label="账户:" prop="account">
											<el-input placeholder="请输入" v-model="formInfo2.account"></el-input>
										</el-form-item>
										<el-form-item label="账号:" prop="accountNumber">
											<el-input placeholder="请输入" v-model="formInfo2.accountNumber"></el-input>
										</el-form-item>
										<el-form-item label="收货人:" prop="receiver">
											<el-input placeholder="请输入" v-model="formInfo2.receiver"></el-input>
										</el-form-item>
									</div>
								</div>
								<div class="zdy_item zdy_item2">
									<div class="economy_div company_div address_div">
										<el-form-item label="收货地址:" prop="address">
											<el-cascader size="large" :options="options" v-model="selectedOptions2" @change="handleChange2">
											</el-cascader>
										</el-form-item>
										<el-form-item label="详细地址:" prop="detailaddress">
											<el-input placeholder="请输入" v-model="formInfo2.detailaddress"></el-input>
										</el-form-item>
									</div>
								</div>
								<div class="zdy_item zdy_cont">
									<div class="zdy_txt">
										<div class="zdy_list">
											<p class="zdy_p">经营行业(非酒类):</p>
											<div class="add" @click="addItem">
												<i class="el-icon-plus"></i>添加
											</div>
										</div>
										<div class="zdy_list">
											<p class="zdy_p">年销售额:</p>
										</div>
									</div>
									<div class="zdy_input">
										<div class="input_box" v-for="(item, index) in operateItem" :key="index">
											<div class="input_div">
												<el-input v-model="item.industry" placeholder="请输入">
												</el-input>
												<el-input v-model="item.sales" placeholder="请输入">
													<template slot="append">万元</template>
												</el-input>
											</div>
											<div class="delinput">
												<span class="el-icon-remove" v-if="index !== 0" @click="deleteItem(item, index)"></span>
											</div>
										</div>
									</div>
								</div>
								<div class="zdy_item zdy_cont">
									<div class="zdy_txt">
										<div class="zdy_list">
											<p class="zdy_p">经营酒类品牌:</p>
											<div class="add" @click="addItem2">
												<i class="el-icon-plus"></i>添加
											</div>
										</div>
										<div class="zdy_list">
											<p class="zdy_p">年销售额:</p>
										</div>
									</div>
									<div class="zdy_input">
										<div class="input_box" v-for="(item, index) in operateItem2" :key="index">
											<div class="input_div">
												<el-input v-model="item.brand" placeholder="请输入"></el-input>
												<el-input v-model="item.sales" placeholder="请输入">
													<template slot="append">万元</template></el-input>
											</div>
											<div class="delinput">
												<span class="el-icon-remove" v-if="index !== 0" @click="
                                                    deleteItem2(item, index)
                                                "></span>
											</div>
										</div>
									</div>
								</div>
								<div class="zdy_item zdy_cont">
									<div class="zdy_txt">
										<div class="zdy_list">
											<p class="zdy_p">经营酒类专卖店:</p>
											<div class="add" @click="addItem3">
												<i class="el-icon-plus"></i>添加
											</div>
										</div>
										<div class="zdy_list">
											<p class="zdy_p">地址:</p>
										</div>
									</div>
									<div class="zdy_input">
										<div class="input_box" v-for="(item, index) in operateItem3" :key="index">
											<div class="input_div">
												<el-input v-model="item.shop" placeholder="请输入"></el-input>
												<el-input v-model="item.address" placeholder="请输入"></el-input>
											</div>
											<div class="delinput">
												<span class="el-icon-remove" v-if="index !== 0" @click="
                                                    deleteItem3(item, index)
                                                "></span>
											</div>
										</div>
									</div>
								</div>
								<div class="zdy_item">
									<p class="zdy_p">
										<label>*</label>主要团购网络及社会关系:
									</p>
									<el-input type="textarea" :rows="4" placeholder="请输入" v-model="formInfo2.other"
										resize="none"></el-input>
								</div>
							</el-form>
							<div class="notice">
								<i class="el-icon-warning-outline"></i>请认真核对以上信息准确无误，没有遗漏
							</div>
							<div class="btn_div">
								<div class="btn_divl" @click="save">提交</div>
								<div class="btn_divr" @click="reset">重置</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-dialog :visible.sync="yzshow" :show-close="false" width="340px" top="20vh" center>
				<div class="yz_box2">
					<p class="dj_ps">
						<span class="dj_ps_s1">请依次点击：</span>
						<span class="dj_ps_s2">{{yztext}}</span>
					</p>
					<div class="yzimg_con" @click="yanZheng">
						<img v-if="yzimg" class="yz_img" :src="yzimg" ref="imageRef1" />
						<div class="yz_cir" v-for="(item, index) in zbarr" :key="index"
							:style="{ left: (item.zbx-10) + 'px', top: (item.zby-10) + 'px' }">{{index+1 }}</div>
					</div>

					<div class="qr_btn2_box">
						<span @click="hqcaptcha">刷新</span>
					</div>
				</div>
			</el-dialog>
		</div>
		<el-dialog :visible.sync="sucshow" :show-close="false" :close-on-click-modal="false" width="340px" top="25vh" center>
			<div class="tip_box">
				<div class="tip_d1 flex2">
					<img src="@/images/join/sumt.png">
				</div>
				<p class="tip_d2">资料提交成功</p>
				<p class="tip_d3">请留意通知！</p>
				<div class="tip_d4">
					<span @click="backHome">确认</span>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { regionData } from "element-china-area-data";
import axios from 'axios';
import { proxyUrl } from "../../api/config";
let CodeToText = {};
for (var x in regionData) {
	var r1 = regionData[x];
	CodeToText[r1.value] = r1.label;
	if (r1.children && r1.children.length > 0) {
		for (var x1 in r1.children) {
			var r2 = r1.children[x1];
			CodeToText[r2.value] = r2.label;
			if (r2.children && r2.children.length > 0) {
				for (var x2 in r2.children) {
					var r3 = r2.children[x2];
					CodeToText[r3.value] = r3.label;
				}
			}
		}
	}
}
export default {
	data() {
		return {
			nowdate: "",
			options: regionData,
			selectedOptions: [],
			selectedOptions2: [],
			formInfo: {
				city: "",
				xzlevel: "",
				regionalPopulation: "",
				cityPopulation: "",
				revenue: "",
				gdp: "",
				prodesc: "",
			},
			rules: {
				regionalPopulation: [
					{
						required: true,
						message: "请输入地区人口",
						trigger: "blur",
					},
				],
				cityPopulation: [
					{
						required: true,
						message: "请输入城市人口",
						trigger: "blur",
					},
				],
				revenue: [
					{
						required: true,
						message: "请输入区域财政收入",
						trigger: "blur",
					},
				],
				gdp: [
					{
						required: true,
						message: "请输入人均GDP",
						trigger: "blur",
					},
				],
				prodesc: [
					{
						required: true,
						message: "请输入产业介绍",
						trigger: "blur",
					},
				],
			},

			formInfo2: {
				company: "",
				legalPerson: "",
				legalPhone: "",
				fzrName: "",
				fzrPhone: "",
				fund: "",
				carprice: "",
				bank: "",
				bankNumber: "",
				account: "",
				accountNumber: "",
				receiver: "",
				detailaddress: "",
				other: "",
			},
			cityList: [],
			operateItem: [
				{
					industry: "",
					sales: "",
				},
			],
			operateItem2: [
				{
					brand: "",
					sales: "",
				},
			],
			operateItem3: [
				{
					shop: "",
					address: "",
				},
			],
			rules2: {
				company: [
					{
						required: true,
						message: "请输入公司名称",
						trigger: "blur",
					},
				],
				legalPerson: [
					{
						required: true,
						message: "请输入法人代表",
						trigger: "blur",
					},
				],
				legalPhone: [
					{
						required: true,
						message: "请输入联系电话",
						trigger: "blur",
					},
					// { pattern: /^1[3456789]\d{9}$/, message: '请输入有效的手机号码', trigger: 'blur' }
				],
				fzrName: [
					{
						required: true,
						message: "请输入负责人",
						trigger: "blur",
					},
				],
				fzrPhone: [
					{
						required: true,
						message: "请输入联系电话",
						trigger: "blur",
					},
					// { pattern: /^1[3456789]\d{9}$/, message: '请输入有效的手机号码', trigger: 'blur' }
				],
				fund: [
					{ required: true, message: "请输入资金", trigger: "blur" },
				],
				staff: [
					{ required: true, message: "请输入人员", trigger: "blur" },
				],
				carprice: [
					{ required: true, message: "请输入车辆", trigger: "blur" },
				],
				other: [
					{ required: true, message: "请输入内容", trigger: "blur" },
				],
			},
			zuhe: "",
			pro: "",
			city: "",
			аrea: "",
			jiamaddress: "",
			isPhone: this.$isMobile,
			yzimg: '',//验证图片
			yztext: '',//验证文字
			yzrule: '',
			zbarr: [],//坐标
			yzshow: false,
			subdata: {},
			sucshow: false,
		};
	},
	created() {
		this.hqcaptcha();
		const date = new Date();
		var year = date.getFullYear();
		var month = date.getMonth() + 1;
		if (month < 10) {
			month = "0" + month;
		}
		var day = date.getDate();
		if (day < 10) {
			day = "0" + day;
		}
		this.nowdate = year + "-" + month + "-" + day;
	},
	beforeDestroy() {
		this.subdata = {};
	},
	methods: {
		// 获取验证码
		async hqcaptcha() {
			this.yzimg = '';
			this.yztext = '';
			this.zbarr = [];
			const res = await this.$api.hqcaptcha();
			if (res.code == 1) {
				this.yztext = res.msg;
				this.yzimg = res.data.img;
				this.yzrule = res.data.yimg;
			}
		},
		tost(text, tp) {
			this.$message({
				message: text,
				type: tp,
				offset: 100,
				duration: 3000
			});
		},
		yanZheng(e) {
			const x = e.layerX;
			const y = e.layerY;
			var zbxy = '';
			if (this.isPhone) {
				zbxy = parseFloat((x * 1.1666).toFixed(1)) + ',' + parseFloat((y * 1.1666).toFixed(1));
			} else {
				zbxy = x + ',' + y;
			}
			var obj3 = {
				zbx: x,
				zby: y,
				zbxy: zbxy,
			}
			if (this.zbarr.length < 4) {
				this.zbarr.push(obj3);
				if (this.zbarr.length >= 4) {
					var arr5 = []
					for (let i = 0; i < this.zbarr.length; i++) {
						arr5.push(this.zbarr[i].zbxy)
					}
					this.check(arr5.join('-') + ';350' + ';233')
				}
			}
		},
		async check(text) {
			var data2 = {
				captcha: text,
				textArr: this.yzrule,
			}
			axios.post(proxyUrl + '/index/check', data2, {
				timeout: 10000
			}).then(res => {
				//data 1验证成功 2验证失败
				if (res.data == 1) {
					this.franchise(this.subdata);
				} else {
					this.tost('验证失败', 'error');
				}
			}).catch(err => {
				this.tost('请求出错', 'error');
			});
		},
		handleChange(value) {
			this.zuhe = CodeToText[value[0]] + "/" + CodeToText[value[1]] + "/" + CodeToText[value[2]];
			this.pro = CodeToText[value[0]];
			this.city = CodeToText[value[1]];
			this.аrea = CodeToText[value[2]];
		},
		handleChange2(value) {
			this.jiamaddress = CodeToText[value[0]] + CodeToText[value[1]] + CodeToText[value[2]];
		},
		setPhone(str) {
			var mobile = /^1[23456789]\d{9}$/,
				phone = /^0\d{2,3}-?\d{7,8}$/;
			if (!mobile.test(str) || !phone.test(str)) {
				return this.tost("请输入正确的联系方式", 'error');
			}
		},
		setPhone2(str) {
			var mobile = /^1[23456789]\d{9}$/,
				phone = /^0\d{2,3}-?\d{7,8}$/;
			if (mobile.test(str) || phone.test(str)) {
				return true;
			} else {
				return false;
			}
		},
		addItem() {
			this.operateItem.push({
				industry: "",
				sales: "",
			});
		},
		deleteItem(item, index) {
			this.operateItem.splice(index, 1);
		},
		addItem2() {
			this.operateItem2.push({
				brand: "",
				sales: "",
			});
		},
		deleteItem2(item, index) {
			this.operateItem2.splice(index, 1);
		},
		addItem3() {
			this.operateItem3.push({
				shop: "",
				address: "",
			});
		},
		deleteItem3(item, index) {
			this.operateItem3.splice(index, 1);
		},
		save() {
			var joincity = this.formInfo; //加盟城市
			var joinsquare = this.formInfo2; //加盟方
			var operateItem = this.operateItem;
			var operateItem2 = this.operateItem2;
			var operateItem3 = this.operateItem3;
			var jmFeijl = [];
			var jmFeijl2 = "";
			if (operateItem[0].industry && operateItem[0].sales) {
				for (var x in operateItem) {
					var r1 = operateItem[x].industry + "/" + operateItem[x].sales + "万";
					jmFeijl.push(r1);
				}
				jmFeijl2 = jmFeijl.join(",");
			} else {
				jmFeijl2 = "";
			}

			var jmJiul = [];
			var jmJiul2 = "";
			if (operateItem2[0].brand && operateItem2[0].sales) {
				for (var x in operateItem2) {
					var r2 = operateItem2[x].brand + "/" + operateItem2[x].sales + "万";
					jmJiul.push(r2);
				}
				jmJiul2 = jmJiul.join(",");
			} else {
				jmJiul2 = "";
			}
			var jmZmd = [];
			var jmZmd2 = "";
			if (operateItem3[0].shop && operateItem3[0].address) {
				for (var x in operateItem3) {
					var r3 = operateItem3[x].shop + "/" + operateItem3[x].address;
					jmZmd.push(r3);
				}
				jmZmd2 = jmZmd.join(",");
			} else {
				jmZmd2 = "";
			}
			if (this.selectedOptions.length <= 0) return this.tost("请选择拟开设城市", 'error');
			if (!joincity.regionalPopulation) return this.tost("请输入地区人口", 'error');
			if (!joincity.cityPopulation) return this.tost("请输入城市人口", 'error');
			if (!joincity.revenue) return this.tost("请输入区域财政收入", 'error');
			if (!joincity.gdp) return this.tost("请输入人均GDP", 'error');
			if (!joincity.prodesc) return this.tost("请输入经济特点及支柱产业介绍", 'error');

			if (!joinsquare.company) return this.tost("请输入公司名称", 'error');
			if (!joinsquare.legalPerson) return this.tost("请输入法人代表", 'error');
			if (!joinsquare.legalPhone) return this.tost("请输入联系电话", 'error');
			if (this.setPhone2(joinsquare.legalPhone) == false) {
				return this.tost("请输入正确的联系方式", 'error');
			}
			if (!joinsquare.fzrName)
				return this.tost("请输入负责人姓名", 'error');
			if (!joinsquare.fzrPhone)
				return this.tost("请输入联系电话", 'error');
			if (this.setPhone2(joinsquare.fzrPhone) == false) {
				return this.tost("请输入正确的联系方式", 'error');
			}
			if (!joinsquare.fund) return this.tost("请输入资金", 'error');
			if (!joinsquare.staff) return this.tost("请输入人员", 'error');
			if (!joinsquare.carprice) return this.tost("请输入车辆", 'error');
			if (!joinsquare.other) return this.tost("请输入主要团购网络及社会关系", 'error');
			var citycode = this.selectedOptions[1] + '00';
			if (joincity.regionalPopulation) {
				var dpnum = joincity.regionalPopulation;
			}
			if (joincity.cityPopulation) {
				var citynum = joincity.cityPopulation;
			}
			if (joincity.revenue) {
				var qumoney = joincity.revenue + "万";
			}
			if (joincity.gdp) {
				var gdp = joincity.gdp;
			}
			if (joinsquare.fund) {
				var jmYus = joinsquare.fund;
			}
			var data = {
				zuhe: this.zuhe,
				pro: this.pro,
				city: this.city,
				аrea: this.аrea,
				citycode: citycode ? citycode : "",
				xzjb: joincity.xzlevel ? joincity.xzlevel * 1 : "",
				dpnum: dpnum ? dpnum : "",
				citynum: citynum ? citynum : "",
				qumoney: qumoney ? qumoney : "",
				gdp: gdp ? gdp : "",
				content: joincity.prodesc,
				jmGs: joinsquare.company,
				jmFaren: joinsquare.legalPerson,
				jmPhone: joinsquare.legalPhone,
				jmFuze: joinsquare.fzrName,
				jmFphone: joinsquare.fzrPhone,
				jmYus: jmYus ? jmYus : "",
				jmRy: joinsquare.staff ? joinsquare.staff : "",
				JmCar: joinsquare.carprice,
				jmYh: joinsquare.bank,
				jmSh: joinsquare.bankNumber,
				jmZhu: joinsquare.account,
				jmZhao: joinsquare.accountNumber,
				jmPeo: joinsquare.receiver,
				jmAddre: this.jiamaddress,
				jmAddress: joinsquare.detailaddress,
				jmFeijl: jmFeijl2,
				jmJiul: jmJiul2,
				jmZmd: jmZmd2,
				jmRg: joinsquare.other,
			};
			this.subdata = data;
			this.yzshow = true;
		},
		franchise(data) {
			axios.post(proxyUrl + '/index/franchise', data, {
				timeout: 10000
			}).then(res => {
				if (res.status == 200) {
					this.yzshow = false;
					this.sucshow = true;
					setTimeout(() => {
						this.reset();
					}, 2000);
				} else {
					this.tost('提交失败', 'error');
				}
			}).catch(err => {
				this.tost('提交失败', 'error');
			});
		},
		reset() {
			this.subdata = {};
			this.hqcaptcha();
			(this.formInfo = {
				city: "",
				xzlevel: "",
				regionalPopulation: "",
				cityPopulation: "",
				revenue: "",
				gdp: "",
				prodesc: "",
			}),
				(this.formInfo2 = {
					company: "",
					legalPerson: "",
					legalPhone: "",
					fzrName: "",
					fzrPhone: "",
					fund: "",
					carprice: "",
					bank: "",
					bankNumber: "",
					account: "",
					accountNumber: "",
					receiver: "",
					address: "",
					detailaddress: "",
					other: "",
				}),
				(this.operateItem = [{ industry: "", sales: "" }]),
				(this.operateItem2 = [{ brand: "", sales: "" }]),
				(this.operateItem3 = [{ shop: "", address: "" }]),
				(this.selectedOptions = []);
			this.selectedOptions2 = [];
			(this.zuhe = ""),
				(this.pro = ""),
				(this.city = ""),
				(this.аrea = ""),
				(this.jiamaddress = "");
		},
		backHome() {
			this.$router.push('/');
		}
	},
};
</script>

<style lang="scss">
.el-input-group__append {
	background-color: transparent !important;
	color: #666;
}
.el-form-item.is-required:not(.is-no-asterisk)
	.el-form-item__label-wrap
	> .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
	color: #d43236 !important;
}
.xingzheng {
	.el-radio {
		margin-right: 20px !important;
	}
}
.tip_box {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	.tip_d1 {
		img {
			width: 130px;
		}
	}
	.tip_d2 {
		color: #ff4a26;
		font-weight: bold;
		font-size: 20px;
		text-align: center;
	}
	.tip_d3 {
		color: #999;
		margin-top: 10px;
		text-align: center;
	}
	.tip_d4 {
		margin-top: 20px;
		span {
			display: inline-block;
			padding: 12px 0;
			border-radius: 5px;
			cursor: pointer;
			text-align: center;
			font-size: 16px;
			color: #fff;
			background-color: #ff4a26;
			width: 100%;
		}
	}
}
.apply_page {
	.el-dialog__header {
		display: none;
	}
	.apply_form_pc {
		width: 100%;
		padding-top: 100px;
		min-height: 900px;
		background-image: url("../../images/bgimg3.png");
		box-sizing: border-box;
		.form_wrap {
			background-position: bottom;
			background-repeat: no-repeat;
			background-image: url("../../images/join/jn_img1.png");
			padding: 30px 20px 60px;
			.fm_tit1 {
				color: #d43236;
				font-size: 40px;
			}
			.fm_tit2 {
				margin: 30px 0;
				color: #666;
				font-size: 18px;
			}
			.container_info {
				padding: 0 30px;
				.bgdiv {
					width: 66%;
					margin: 0 auto;
					padding-top: 30px;
					background: #fff;
					.divtit {
						font-size: 22px;
						font-weight: 550;
						letter-spacing: 1px;
					}
					.form_border {
						margin: 0 20px;
						border-bottom: 1px dashed #ddd;
						.top_form {
							width: 80%;
							margin: 0 auto;
							padding-bottom: 40px;
							text-align: left;
							.zdy_item {
								margin-bottom: 22px;
								&:last-child {
									margin-bottom: 0;
								}
								.zdy_p {
									color: #333;
									font-weight: 550;
									font-size: 15px;
									letter-spacing: 1px;
									margin: 0;
									margin-bottom: 16px;
									label {
										color: #d43236;
										font-size: 16px;
									}
								}
								.economy_div {
									display: flex;
									align-items: center;
									flex-wrap: wrap;
									justify-content: space-between;
									.el-form-item {
										width: 48%;
										&:nth-child(3) {
											margin-bottom: 0;
										}
										&:nth-child(4) {
											margin-bottom: 0;
										}
										.el-form-item__label {
											float: unset;
											line-height: 32px;
										}
										.el-form-item__content {
											margin-left: 0 !important;
										}
									}
								}
								.company_div {
									.el-form-item {
										width: 48%;
										.el-form-item__label {
											color: #333;
											font-weight: 550;
											font-size: 15px;
											letter-spacing: 1px;
											margin: 0;
											margin-bottom: 16px;
										}
										.el-form-item__label {
											display: block;
											line-height: unset !important;
										}
									}
								}
								.bank_div {
									.el-form-item {
										&:nth-child(3) {
											margin-bottom: 22px !important;
										}
										&:nth-child(4) {
											margin-bottom: 22px !important;
										}
										&:last-child(4) {
											margin-bottom: 0;
										}
									}
								}
							}
							.zdy_item2 {
								margin-bottom: 0;
								.el-cascader {
									width: 100%;
								}
							}
							.zdy_cont {
								.zdy_p {
									margin-bottom: 0;
								}
								.zdy_txt {
									display: flex;
									align-items: center;
									justify-content: space-between;
									.zdy_list {
										display: flex;
										align-items: center;
										justify-content: space-between;
										width: 48%;
										margin-bottom: 16px;
										.add {
											border: 1px solid #d43236;
											color: #d43236;
											border-radius: 10px;
											font-size: 14px;
											width: 56px;
											height: 20px;
											display: flex;
											align-items: baseline;
											justify-content: center;
											cursor: pointer;
											i {
												margin-right: 2px;
												font-size: 12px;
											}
										}
									}
								}
								.zdy_input {
									.input_box {
										margin-bottom: 22px;
										&:last-child {
											margin-bottom: 0;
										}
										.input_div {
											display: flex;
											align-items: center;
											justify-content: space-between;
											.el-input {
												width: 48%;
											}
										}
										.delinput {
											text-align: right;
											margin-top: 10px;
											span {
												color: #d43236;
												cursor: pointer;
											}
										}
									}
								}
							}
						}
						.bot_form {
							padding-bottom: 20px;
						}
						.notice {
							font-size: 14px;
							text-align: left;
							width: 80%;
							margin: 0 auto;
							color: #d43236;
							i {
								color: #d43236;
								margin-right: 4px;
							}
						}
						.btn_div {
							display: flex;
							align-items: center;
							justify-content: center;
							width: 80%;
							margin: 0 auto;
							text-align: center;
							padding-top: 50px;
							padding-bottom: 40px;
							& > div {
								cursor: pointer;
								background: #fff;
								border: 1px solid #dcdfe6;
								box-sizing: border-box;
								padding: 12px 20px;
								font-size: 16px;
								border-radius: 4px;
							}
							.btn_divl {
								width: 25%;
								background: #d43236;
								color: #fff;
								border-color: #d43236;
								margin-right: 20px;
							}
						}
					}
				}
			}
			.rd_box {
				margin: 50px 0 30px 0;
			}
		}
		.yz_box {
			.dj_ps {
				margin-bottom: 20px;
				.dj_ps_s1 {
					font-size: 16px;
				}
				.dj_ps_s2 {
					font-weight: 600;
					font-size: 16px;
					color: #222;
				}
			}
			.yzimg_con {
				position: relative;
				width: 350px;
				height: 233px;
				.yz_img {
					width: 350px;
					height: 233px;
					display: block;
					cursor: pointer;
				}
				.yz_cir {
					position: absolute;
					width: 20px;
					height: 20px;
					border: 2px solid #fff;
					border-radius: 50%;
					pointer-events: none;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #fff;
					font-size: 14px;
				}
			}

			.qr_btn2_box {
				margin-top: 20px;
				display: flex;
				justify-content: space-between;
				span {
					padding: 12px 0;
					border-radius: 5px;
					cursor: pointer;
					text-align: center;
					font-size: 16px;
					color: #fff;
					background-color: #2979ff;
					width: 100%;
				}
			}
		}
	}
	.apply_form_phone {
		background-image: url("../../images/bgimg3.png");
		.form_wrap {
			background-position: bottom;
			background-repeat: no-repeat;
			background-image: url("../../images/join/jn_img1.png");
			padding: 1.6rem 0.4rem 2.6rem;
			.fm_tit1 {
				color: #d43236;
				font-size: 0.5rem;
				font-weight: bold;
			}
			.fm_tit2 {
				margin: 0.1rem 0 0.4rem;
				color: #666;
				font-size: 0.4rem;
			}
			.container_info {
				.bgdiv {
					width: 100%;
					margin: 0 auto;
					padding-top: 0.3rem;
					background: #fff;
					.divtit {
						font-size: 0.5rem;
						font-weight: 550;
						letter-spacing: 1px;
						margin-bottom: 0.3rem;
					}
					.form_border {
						margin: 0 0.35rem;
						border-bottom: 1px dashed #ddd;
						.top_form {
							text-align: left;
							.zdy_item {
								margin-bottom: 0.5rem;
								&:last-child {
									margin-bottom: 0;
								}
								.zdy_p {
									color: #333;
									font-weight: 550;
									font-size: 0.35rem;
									letter-spacing: 1px;
									margin: 0;
									margin-bottom: 0.36rem;
									label {
										color: #d43236;
										font-size: 0.36rem;
									}
								}
								.economy_div {
									display: flex;
									align-items: center;
									flex-wrap: wrap;
									justify-content: space-between;
									.el-form-item {
										width: 48%;
										&:nth-child(3) {
											margin-bottom: 0;
										}
										&:nth-child(4) {
											margin-bottom: 0;
										}
										.el-form-item__label {
											float: unset;
											line-height: 0.78rem;
										}
										.el-form-item__content {
											margin-left: 0 !important;
										}
									}
								}
								.company_div {
									.el-form-item {
										width: 48%;
										.el-form-item__label {
											color: #333;
											font-weight: 550;
											font-size: 0.36rem;
											letter-spacing: 1px;
											margin: 0;
											margin-bottom: 0.36rem;
										}
										.el-form-item__label {
											display: block;
											line-height: unset !important;
										}
									}
								}
								.bank_div {
									.el-form-item {
										&:nth-child(3) {
											margin-bottom: 0.5rem !important;
										}
										&:nth-child(4) {
											margin-bottom: 0.5rem !important;
										}
										&:last-child(4) {
											margin-bottom: 0;
										}
									}
								}
							}
							.zdy_item2 {
								margin-bottom: 0;
								.el-cascader {
									width: 100%;
								}
							}
							.zdy_cont {
								.zdy_p {
									margin-bottom: 0;
								}
								.zdy_txt {
									display: flex;
									align-items: center;
									justify-content: space-between;
									.zdy_list {
										display: flex;
										align-items: center;
										justify-content: space-between;
										width: 48%;
										margin-bottom: 0.36rem;
										.add {
											border: 1px solid #d43236;
											color: #d43236;
											border-radius: 10px;
											font-size: 0.32rem;
											width: 1.36rem;
											height: 0.4rem;
											display: flex;
											align-items: baseline;
											justify-content: center;
											cursor: pointer;
											i {
												margin-right: 2px;
												font-size: 0.3rem;
											}
										}
									}
								}
								.zdy_input {
									.input_box {
										margin-bottom: 0.5rem;
										&:last-child {
											margin-bottom: 0;
										}
										.input_div {
											display: flex;
											align-items: center;
											justify-content: space-between;
											.el-input {
												width: 48%;
											}
										}
										.delinput {
											text-align: right;
											margin-top: 0.25rem;
											span {
												color: #d43236;
												cursor: pointer;
											}
										}
									}
								}
							}
						}
						.bot_form {
							padding-bottom: 0.5rem;
						}
						.notice {
							font-size: 0.33rem;
							text-align: left;
							color: #d43236;
							i {
								color: #d43236;
								margin-right: 4px;
							}
						}
						.btn_div {
							display: flex;
							align-items: center;
							justify-content: center;
							margin: 0 auto;
							text-align: center;
							padding: 1rem 0;
							& > div {
								background: #fff;
								border: 1px solid #dcdfe6;
								box-sizing: border-box;
								padding: 0.3rem 0.5rem;
								font-size: 0.36rem;
								border-radius: 4px;
							}
							.btn_divl {
								width: 50%;
								background: #d43236;
								color: #fff;
								margin-right: 0.5rem;
							}
						}
					}
				}
			}
		}
		.el-dialog__body {
			padding: 20px !important;
		}
		.yz_box2 {
			.dj_ps {
				margin-bottom: 20px;
				.dj_ps_s1 {
					font-size: 15px;
				}
				.dj_ps_s2 {
					font-weight: 600;
					font-size: 15px;
					color: #222;
				}
			}
			.yzimg_con {
				position: relative;
				width: 300px;
				height: 200px;
				.yz_img {
					width: 300px;
					height: 200px;
					display: block;
					cursor: pointer;
				}
				.yz_cir {
					position: absolute;
					width: 20px;
					height: 20px;
					border: 2px solid #fff;
					border-radius: 50%;
					pointer-events: none;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #fff;
					font-size: 14px;
				}
			}

			.qr_btn2_box {
				margin-top: 20px;
				display: flex;
				justify-content: space-between;
				span {
					padding: 12px 0;
					border-radius: 5px;
					cursor: pointer;
					text-align: center;
					font-size: 16px;
					color: #fff;
					background-color: #2979ff;
					width: 100%;
				}
			}
		}
	}
}
</style>